export const generateDiagnostic = (activeDyn: any, activeDiagnostic: any, sortDyns: any) => {

    console.log({activeDyn, activeDiagnostic, sortDyns})

    const initialOpeStatus = sortDyns?.variables?.find((variable: any) => variable.variable === "Estado Pozo Inicial")?.value
    const finalOpeStatus = sortDyns?.variables?.find((variable: any) => variable.variable === "Estado Pozo Final")?.value
    const spm = sortDyns?.variables?.find((variable: any) => variable.variable === "SPM")?.value
    const tiro = sortDyns?.variables?.find((variable: any) => variable.variable === "Tiro")?.value
    const stl = activeDyn?.strokeLength
    const currentPercentageMaxLoad = activeDyn?.currentPercentageMaxLoad
    
    const bootomHoleCondition = activeDiagnostic?.bottomHoleCondition;
    const bottomHoleFillage = activeDiagnostic?.bottomHoleFillage;
    const mpt = activeDyn?.mpt
    const ept = activeDyn?.ept

    let diagnostic  = ''

    if (initialOpeStatus && finalOpeStatus) {

        let initialOpeStatusText = initialOpeStatus
        if (initialOpeStatus === "Observación") {
            initialOpeStatusText = "en Observación"
        }

        let finalOpeStatusText = finalOpeStatus 
        if (finalOpeStatus === "Observación") {
            finalOpeStatusText = "en Observación"
        }
        diagnostic = `Pozo encontrado  ${initialOpeStatusText} a la salida del las cuadrillas el pozos queda ${finalOpeStatusText}`
    }

    if (spm){
        diagnostic = `${diagnostic}, unidad de superficie opera a ${spm} spm`
    }

    if (tiro && stl){
        diagnostic = `${diagnostic}, tiro ${tiro} con carrera de superficie de ${stl}`
    }

    if (currentPercentageMaxLoad){
        let cargaStatetext = ''

        const currentPercentageMaxLoadText =  typeof currentPercentageMaxLoad === 'number' ? currentPercentageMaxLoad.toFixed(2) : currentPercentageMaxLoad

        if (currentPercentageMaxLoad < 50) {
            cargaStatetext = 'bajas cargas estructurales'
        } else if (currentPercentageMaxLoad >= 50 && currentPercentageMaxLoad < 80) {
            cargaStatetext = 'cargas de operacion normales'
        } else if (currentPercentageMaxLoad >= 80 && currentPercentageMaxLoad < 95) {
            cargaStatetext = 'aceptables altas cargas estructurales '
        } else if (currentPercentageMaxLoad >= 95) {
            cargaStatetext = 'sobre cargas estructurales'
        }

        diagnostic = `${diagnostic}, carga máxima en la undiad de superficie opera con ${cargaStatetext} llegando al  ${currentPercentageMaxLoadText} % de la carga máxima soportada por estructura`
    }

    if (bootomHoleCondition) {
        diagnostic = `${diagnostic}, condicion principal el fono es ${bootomHoleCondition}`

        if (['Golpe de Fluido','Inteferencia por Gas','Buenas Condiciones'].includes(bootomHoleCondition)) {
            let eptState = ''
            const bottomHoleFillageText = typeof bottomHoleFillage === 'number' ? bottomHoleFillage.toFixed(2) : bottomHoleFillage
            if (bottomHoleFillage<20){
                eptState = `con un llenado crtico de la bomba de subuelo de ${bottomHoleFillageText}% `
            }else if (bottomHoleFillage>=20 && bottomHoleFillage<50){
                eptState = `con un llenado medio-bajo de la bomba de subuelo de ${bottomHoleFillageText}%`
            }else if (bottomHoleFillage>=50 && bottomHoleFillage<80){
                eptState = `con un llenado medio-aceptable de la bomba de subuelo de ${bottomHoleFillageText}%`
            }else if (bottomHoleFillage>=80){
                eptState = `con un buen llenado de la bomba de subuelo de ${bottomHoleFillageText}%`
            }

            const eptText = typeof ept === 'number' ? ept.toFixed(2) : eptState
            const mptText = typeof mpt === 'number' ? mpt.toFixed(2) : mpt

            diagnostic = `${diagnostic}, la bomba de subuelo opera con un recorrido efectivo de  ${eptText} ept vs un recorrido total del piston de ${mptText} mpt, ${eptState}`
        }

    }

    return diagnostic
}